import { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { ShieldAlert, Loader2 } from 'lucide-react'
import { AdminLayout } from './AdminLayout'
import { ErrorBoundary } from '../components/ErrorBoundary'
import { get } from '../lib/api'
import { useAuth } from '../store'

import Dashboard from './pages/Dashboard'
import UsersPage from './pages/Users'
import UserDetail from './pages/UserDetail'
import Finance from './pages/Finance'
import Treasury from './pages/Treasury'
import Accounting from './pages/Accounting'
import Ledger from './pages/Ledger'
import TreasuryStatus from './pages/TreasuryStatus'
import Wallets from './pages/Wallets'
import Trading from './pages/Trading'
import KycPage from './pages/Kyc'
import Tickets from './pages/Tickets'
import ChainPage from './pages/Chain'
import Content from './pages/Content'
import Announcements from './pages/Announcements'
import PulseAdmin from './pages/Pulse'
import Commerce from './pages/Commerce'
import EmailAdmin from './pages/Email'
import StakingAdmin from './pages/Staking'
import SettingsPage from './pages/Settings'
import Sms from './pages/Sms'
import Staff from './pages/Staff'
import Logs from './pages/Logs'

export default function AdminApp() {
  const { user, loading } = useAuth()
  const loc = useLocation()
  const [perms, setPerms] = useState<string[] | null>(null)
  const [denied, setDenied] = useState(false)

  useEffect(() => {
    if (!user) return
    get('/admin/overview?days=1')
      .then((r: any) => setPerms(r.me?.perms ?? []))
      .catch(() => setDenied(true))
  }, [user])

  if (loading) {
    return (
      <div className="grid h-screen place-items-center bg-ink-950">
        <Loader2 className="h-8 w-8 animate-spin text-brand-400" />
      </div>
    )
  }
  if (!user) return <Navigate to="/login?next=/admin" replace />

  if (denied) {
    return (
      <div className="grid min-h-screen place-items-center bg-ink-950 p-6">
        <div className="card max-w-md p-8 text-center">
          <ShieldAlert className="mx-auto mb-4 h-10 w-10 text-down" />
          <h2 className="mb-2 text-lg font-bold text-white">دسترسی محدود</h2>
          <p className="text-sm leading-7 text-slate-400">
            حساب شما مجوز ورود به پنل مدیریت ارزینو را ندارد. در صورت نیاز با مالک سامانه تماس بگیرید.
          </p>
        </div>
      </div>
    )
  }
  if (perms === null) {
    return (
      <div className="grid h-screen place-items-center bg-ink-950">
        <Loader2 className="h-8 w-8 animate-spin text-brand-400" />
      </div>
    )
  }

  return (
    <AdminLayout perms={perms}>
      <ErrorBoundary key={loc.pathname}>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:id" element={<UserDetail />} />
        <Route path="kyc" element={<KycPage />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="finance" element={<Finance />} />
        <Route path="wallets" element={<Wallets />} />
        <Route path="treasury" element={<Treasury />} />
        <Route path="accounting" element={<Accounting />} />
        <Route path="ledger" element={<Ledger />} />
        <Route path="treasury-status" element={<TreasuryStatus />} />
        <Route path="trading" element={<Trading />} />
        <Route path="chain" element={<ChainPage />} />
        <Route path="staking" element={<StakingAdmin />} />
        <Route path="content" element={<Content />} />
        <Route path="announcements" element={<Announcements />} />

        <Route path="pulse" element={<PulseAdmin />} />


        <Route path="commerce" element={<Commerce />} />
        <Route path="email" element={<EmailAdmin />} />
        <Route path="sms" element={<Sms />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="staff" element={<Staff />} />
        <Route path="logs" element={<Logs />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
      </ErrorBoundary>
    </AdminLayout>
  )
}
